import { Suspense, lazy } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Navigate, Outlet, useLocation } from 'react-router';

import { RegisterAdvisorLayout, RegistrationContextProvider } from '@zeta-commons';
import { LoadingScreen } from '@zeta-core';
import { RouterLinks } from '../../app-route-paths';
import { CompactErrorPage } from '../../layouts/compact-layout';
import AuthErrorBoundary from './logged-in-error-boundary';

const PersonalDetailsRegisterationPage = lazy(() => import('../../pages/auth/registration/personal-details'));
const PasswordSetUpRegisterationPage = lazy(() => import('../../pages/auth/signup/password-set-up'));
const VerificationRegisterationPage = lazy(() => import('../../pages/auth/signup/verification'));

const OutletWrapper = () => {
  const location = useLocation();
  return <Outlet context={location.state} />;
};

const RegistrationRoutes = [
  {
    path: 'registration',
    element: (
      <ErrorBoundary FallbackComponent={CompactErrorPage}>
        <RegistrationContextProvider>
          <AuthErrorBoundary />
        </RegistrationContextProvider>
      </ErrorBoundary>
    ),
    children: [
      {
        path: '',
        children: [
          { element: <Navigate to={RouterLinks.registerPersonalDetails} replace />, index: true },
          {
            path: 'main',
            element: (
              <RegisterAdvisorLayout>
                <Suspense fallback={<LoadingScreen />}>
                  <OutletWrapper />
                </Suspense>
              </RegisterAdvisorLayout>
            ),
            children: [
              {
                path: 'personal-details',
                element: <PersonalDetailsRegisterationPage />,
              },
              {
                path: 'verification',
                element: <VerificationRegisterationPage />,
              },
              {
                path: 'password-set-up',
                element: <PasswordSetUpRegisterationPage />,
              },
              {
                path: '',
                element: <Navigate to="personal-details" replace />,
              },
            ],
          },
          {
            path: '',
            element: <Navigate to={RouterLinks.registerPersonalDetails} replace />,
          },
        ],
      },
      {
        path: '*',
        element: <Navigate to={RouterLinks.registerPersonalDetails} replace />,
      },
    ],
  },
];

export default RegistrationRoutes;
